import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { EditDataScadenza as EditDataScadenzaReducer } from '../../reducers/r_index';
import { SendLicenseDetails as SendLicenseDetailsReducer } from '../../reducers/r_index';
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';

//Components
import EstendiLicenzaCmp from '../../components/gestione_licenze/EstendiLicenzaCmp';

// Material helpers
import { withStyles } from '@material-ui/core';


// Component styles
const styles = theme => ({
});

class EstendiLicenza extends Component {

    render() {
        const { ...props } = this.props;

        return (
            <EstendiLicenzaCmp {...props} />
        );

    }
}

EstendiLicenza.propTypes = {
    //editDataScadenza
    editDataScad: PropTypes.func.isRequired,
    editDataScadRequestStatus: PropTypes.string.isRequired,
    editDataScadErrorMessage: PropTypes.string,
    new_data_scadenza: PropTypes.any,
    hasScadenza: PropTypes.bool.isRequired,
    num_mesi: PropTypes.any.isRequired,

    //sendLicenseDetails
    sendLicenseDetails: PropTypes.func.isRequired,
    sendLicenseDetailsStatus: PropTypes.string.isRequired,
    sendLicenseDetailsErrorMessage: PropTypes.string,
    isSent: PropTypes.string.isRequired,

    isChanged: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,

    validateField: PropTypes.func.isRequired,

    resetEditDataScad: PropTypes.func.isRequired,
    showEditDataScadDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    selected_license: PropTypes.shape({}).isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,

};


const mapDispatchToProps = dispatch => ({
    editDataScad: (pk, data_scadenza, codiceUtente) => { dispatch(EditDataScadenzaReducer.creators.editDataScadRequest(pk, data_scadenza, codiceUtente)) },

    sendLicenseDetails: (pk, email) => { dispatch(SendLicenseDetailsReducer.creators.sendLicenseDetailsRequest(pk, email)); },

    initializeFields: (value) => { dispatch(EditDataScadenzaReducer.creators.initializeFields(value)) },
    handleChangeField: (field, newValue) => { dispatch(EditDataScadenzaReducer.creators.handleChangeField(field, newValue)) },
    validateField: (field) => { dispatch(EditDataScadenzaReducer.creators.validateField(field)) },



    resetEditDataScad: () => { dispatch(EditDataScadenzaReducer.creators.resetEditDataScad()); },
    showEditDataScadDialog: () => { dispatch(EditDataScadenzaReducer.creators.showEditDataScadDialog()); },

    refreshLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    //editDataScadenza
    editDataScadRequestStatus: state['edit-data-scadenza-license'].status,
    editDataScadErrorMessage: state['edit-data-scadenza-license'].error,
    isOpen: state['edit-data-scadenza-license'].isOpen,

    new_data_scadenza: state['edit-data-scadenza-license'].new_data_scadenza,
    hasScadenza: state['edit-data-scadenza-license'].hasScadenza,
    num_mesi: state['edit-data-scadenza-license'].num_mesi,
    errorText: state['edit-data-scadenza-license'].errorText,

    isChanged: state['edit-data-scadenza-license'].isChanged,
    isValid: state['edit-data-scadenza-license'].isValid,

    //sendLicenseDetails
    sendLicenseDetailsStatus: state['send-license-details'].status,
    sendLicenseDetailsErrorMessage: state['send-license-details'].error,
    isSent: state['send-license-details'].isSent,

    selectedRowIndex: state['filtro-licenze'].selectedRowIndex,
    selected_license: state['filtro-licenze'].selected_license,

    codiceUtente: state['logged-user'].codiceUtente,

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EstendiLicenza));